'use client';

import { useEffect, useState } from 'react';

let timeAgoPromise = null;

const loadTimeAgo = () => {
  if (timeAgoPromise === null) {
    timeAgoPromise = Promise.all([
      import('javascript-time-ago'),
      import('javascript-time-ago/locale/en'),
      import('javascript-time-ago/locale/de'),
    ]).then(([{ default: TimeAgo }, { default: en }, { default: de }]) => {
      TimeAgo.addLocale(en);
      TimeAgo.addLocale(de);
      return TimeAgo;
    });
  }

  return timeAgoPromise;
};

const useTimeSince = (locale, value, cb = () => {}) => {
  const [elapsed, setElapsed] = useState('now');

  useEffect(() => {
    (async () => {
      const TimeAgo = await loadTimeAgo();
      const timeAgo = new TimeAgo(locale);

      const formatted = timeAgo.format(parseInt(value, 10), 'mini');
      setElapsed(formatted);

      cb(formatted); // for testing only
    })();
  }, [locale, value, cb]);

  return elapsed;
};

export default useTimeSince;
